import { createContext, useContext } from 'react';
import type { FiltrosGestaoImpostos, HistoricoMensalItem } from '@/services/GestaoImpostos';
import type { ProjecaoAno, ProjecaoCompleta } from '@/lib/tax/cronogramaTransicaoLC214';

export type GestaoImpostosContextValue = {
  selecaoMensalValida: boolean;
  buscaAplicada: boolean;
  handleBuscar: () => void;
  handleLimparFiltrosGlobais: () => void;
  filtrosAplicados: FiltrosGestaoImpostos;

  isLoadingSituacaoAtual: boolean;
  /** Total de Vendas real do período (não projetado — vem direto de Apuração Detalhada). */
  totalVendas: number | null;
  /** Projeção do ano da situação atual (ano do período filtrado, limitado a 2026-2033). */
  projecaoAnoAtual: ProjecaoAno | null;
  /** Projeção completa 2026-2033, calculada em cima dos mesmos totais reais da Situação Atual. */
  projecaoCompleta: ProjecaoCompleta | null;

  aliquotaIS: number; // percentual (0-100), editável manualmente — sem persistência (ver design.md)
  setAliquotaIS: (valor: number) => void;

  historico: HistoricoMensalItem[];
  isLoadingHistorico: boolean;
};

export const GestaoImpostosContext = createContext<GestaoImpostosContextValue | null>(null);

export function useGestaoImpostosContext(): GestaoImpostosContextValue {
  const ctx = useContext(GestaoImpostosContext);
  if (!ctx) {
    throw new Error('useGestaoImpostosContext deve ser usado dentro de GestaoImpostosProvider');
  }
  return ctx;
}
